"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
exports.__esModule = true;
var component_svg_1 = __importDefault(require("@doordash/component-svg"));
var design_language_1 = require("@doordash/design-language");
var lodash_1 = require("lodash");
var React = __importStar(require("react"));
/* tslint:disable:max-line-length */
var SecondCard = function () {
    var theme = React.useContext(design_language_1.ThemingContext);
    var strokeColor = lodash_1.get(theme, 'Colors.TextAction', design_language_1.Colors.SystemRed60);
    return (React.createElement(component_svg_1["default"], { height: 48, width: 48, strokeWidth: "2", fill: "none", strokeLinejoin: "round", strokeMiterlimit: "10", strokeLinecap: "round" },
        React.createElement("path", { d: "M33.7607 10H8.99365C7.88908 10 6.99365 10.8954 6.99365 12V26.3063C6.99365 27.4108 7.88908 28.3063 8.99365 28.3063H33.7607C34.8652 28.3063 35.7607 27.4108 35.7607 26.3063V12C35.7607 10.8954 34.8652 10 33.7607 10Z", stroke: strokeColor }),
        React.createElement("path", { d: "M7.38239 14.7946H35.4215", stroke: strokeColor }),
        React.createElement("path", { d: "M41.3779 18.1531H13.3764C12.2718 18.1531 11.3764 19.0486 11.3764 20.1531V36.3354C11.3764 37.44 12.2718 38.3354 13.3764 38.3354H41.3779C42.4824 38.3354 43.3779 37.44 43.3779 36.3354V20.1531C43.3779 19.0486 42.4824 18.1531 41.3779 18.1531Z", fill: "white" }),
        React.createElement("path", { d: "M39.7607 20H14.9937C13.8891 20 12.9937 20.8954 12.9937 22V36.3063C12.9937 37.4108 13.8891 38.3063 14.9937 38.3063H39.7607C40.8652 38.3063 41.7607 37.4108 41.7607 36.3063V22C41.7607 20.8954 40.8652 20 39.7607 20Z", fill: "white", stroke: strokeColor }),
        React.createElement("path", { d: "M13.3824 24.7946H41.4215", stroke: strokeColor }),
        React.createElement("path", { d: "M36.0945 30.4607H32.6075C31.4039 30.4607 30.4282 31.4364 30.4282 32.64C30.4282 33.8436 31.4039 34.8194 32.6075 34.8194H36.0945C37.2981 34.8194 38.2738 33.8436 38.2738 32.64C38.2738 31.4364 37.2981 30.4607 36.0945 30.4607Z", stroke: strokeColor })));
};
/* tslint:enable:max-line-length */
exports["default"] = SecondCard;
